/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["h1[_ngcontent-%COMP%]{margin-top:25px}.subheader[_ngcontent-%COMP%]{margin:0 0 30px;font-size:14px}.no-orders[_ngcontent-%COMP%]{margin-top:65px;font-style:italic;text-align:center;color:#999}"];
export { styles as styles };
